// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'typeahead.js/dist/typeahead.jquery';
import Bloodhound from 'typeahead.js/dist/bloodhound';

export default class Typeahead extends WebComponent {
	constructor(props) {
		super(props);
		this.typeaheadVal = null;
	}
	didMount() {
		const {
			typeaheadOptions,
			typeaheadLabel,
			typeaheadTarget,
			typeaheadUrl,
			typeaheadNotFoundLabel,
			typeaheadPrefetch,
			typeaheadOnBlurAutoselect
		} = this.props;
		const self = this;

		this.typeaheadVal = document.querySelector(typeaheadLabel).value;

		const itemsLimit = function() {
			return (!!typeaheadOptions && typeaheadOptions.hasOwnProperty('max'))
				? parseInt(typeaheadOptions.max) - 1 || Infinity
				: Infinity;
			};

		const source = new Bloodhound({
				datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
				queryTokenizer: Bloodhound.tokenizers.whitespace,
				remote: {
					url: typeaheadUrl,
					prepare: function (query, settings) {
						return {
							url: settings.url,
							data: {
								q: query
							},
							method: 'POST'
						};
					},
					transform: function (response) {
						return response.items;
					}
				},
				...(typeaheadPrefetch !== false) ? {prefetch: typeaheadUrl} : ''
			});

		$(typeaheadLabel).typeahead(
				typeaheadOptions,
				{
					source: source,
					display: 'title',
					limit: itemsLimit(),
					templates: {
						suggestion: function (item) {
							return '<div>' + item.title + '</div>'
						},
						notFound: function (item) {
							return '<div class="tt-suggestion tt-not-found">' + typeaheadNotFoundLabel + '</div>'
						}
					}
				})
				.on('typeahead:select', function (e, item) {
					$(typeaheadTarget).val(item.id).trigger('requestValidation');
					self.checkValueChange(typeaheadLabel);
				})
				.on('typeahead:change', function(e){
					self.checkValueChange(typeaheadLabel);
				})
				.on('blur', function (e) {
					/*
					Pokud chci, aby mi typeahead vrátil první položku,
					pokud je ve výpisu (selectu) pouze jedna (to co je napsané v inputu se musí rovnat první možnosti v nabízeném selectu),
					při blur efektu, musím zapnout propertu.
					Příklad pro PSČ:
					V inputu je 54701 (validní vstup, který se rovná pouze jedné položce ve výběru).
					Se zaplou propertou Ramjet zvaliduje a vyhodnocuje správnost, jinak vrací chybu, protože se nevybralo ze selectu
					 */
					if (typeaheadOnBlurAutoselect){
						const instance = $(typeaheadLabel).data('tt-typeahead');
						const selectables = $(typeaheadLabel).siblings(".tt-menu").find(".tt-selectable");
						const selectablesLavel = selectables.map(function (index, item){
							return item.innerText;
						});
						if (selectablesLavel[0] == instance.input.query){
							$(selectables[0]).trigger("click")
						}
					}
					$(typeaheadTarget).trigger('requestValidation');
				})
				.on('typeahead:asyncrequest', function (e) {
					self.element.classList.add('is-in-progress');
				})
				.on('typeahead:asynccancel, typeahead:asyncreceive', function (e) {
					self.element.classList.remove('is-in-progress');
				});
		let isChromeDetect = navigator.userAgent.includes('Chrome');
	    if(isChromeDetect) {
			$(typeaheadLabel).attr('autocomplete', 'none');
		} else {
			$(typeaheadLabel).attr('autocomplete', 'off');
		}
		const instance = $(typeaheadLabel).data('tt-typeahead');
		instance.input.onSync('queryChanged', function () {
			$(typeaheadTarget).val('');
		});
	}

	checkValueChange(element) {
		const typeaheadVal = document.querySelector(element).value;

		if (typeaheadVal != this.typeaheadVal) {
			this.dispatchEvent({type: 'change'});
			this.typeaheadVal = typeaheadVal;
		}
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Typeahead.js